import React, { useEffect, useState } from 'react'

import { AddToBagVerification } from '@pb/components'
import { getCookie } from '@pb/utils'
import { useSelector, useDispatch } from 'react-redux'

import { CART_ROUTES } from 'App/constants'
import { operationHideAddToBag } from 'features/favourites/duck/operations'
import {
  getAddToBagError,
  getAddToBagVerificationItem,
  getShowAddToBagVerification,
} from 'features/favourites/duck/selectors'
import { MiniCartData } from 'features/favourites/duck/types'

import { ADD_TO_BAG_VERIFICATION_TIMESPAN } from '../../constant'
import {
  getAddToBagVerificationFlags,
  getAddToBagVerificationCompositionLabels,
  getProductInformation,
  handleRedirectToCart,
} from '../../helpers'
import { addToBagVerificationLabels } from '../../labels'

const FavouritesAddToBagVerification: React.FC = () => {
  const [showAddToBagVerification, setShowAddToBagVerification] = useState(false)
  const shouldShowAddToBagVerification = useSelector(getShowAddToBagVerification)

  const addToBagVerificationProductDetails = useSelector(getAddToBagVerificationItem)
  const addToBagError = useSelector(getAddToBagError)
  const dispatch = useDispatch()

  const userCookie = JSON.parse(String(getCookie('userCookie')))
  const addToBagVerificationFlags = getAddToBagVerificationFlags()

  useEffect(() => {
    if (shouldShowAddToBagVerification) {
      setShowAddToBagVerification(true)
    }
  }, [shouldShowAddToBagVerification])

  return (
    <>
      {showAddToBagVerification && (
        <AddToBagVerification
          isShowing={showAddToBagVerification}
          isError={addToBagError.showError}
          productInformation={getProductInformation(
            addToBagVerificationProductDetails as MiniCartData,
          )}
          timespan={ADD_TO_BAG_VERIFICATION_TIMESPAN}
          cartUrl={CART_ROUTES.CartOverview.path}
          transitionFrom={
            process.env.ADD_TO_BAG_VERTIFICATION_TRANSITION_FROM === 'top' ? 'top' : 'right'
          }
          size={process.env.ADD_TO_BAG_VERIFICATION_SIZE === 'large' ? 'large' : 'small'}
          shoppingBagItems={userCookie?.cartCount || 0}
          addToBagVerificationCompositionLabels={getAddToBagVerificationCompositionLabels()}
          labels={addToBagVerificationLabels(addToBagError)}
          onGoToCart={handleRedirectToCart}
          onExit={() => {
            setShowAddToBagVerification(false)
            dispatch(operationHideAddToBag())
          }}
          {...addToBagVerificationFlags}
        />
      )}
    </>
  )
}

export default FavouritesAddToBagVerification
